<template>
  <div class="box wrapper-payroll-employee">
    <h2 class="title is-4 has-text-primary title-payroll-employee">
      Datos del Empleado
    </h2>
    <div class="columns is-multiline">
      <div class="column is-12">
        <BField
          label-for="rfc-search"
          label="Buscar/crear empleado por RFC"
        >
          <BAutocomplete
            id="rfc-search"
            :value="text"
            field="rfc.rfc"
            placeholder="XAXX010101000"
            :data="employees"
            :loading="isFetching"
            open-on-focus
            @keyup.native="getEmployeesByRfc"
            @select="onSelect"
            @input="onInput"
          >
            <template slot="header">
              <RouterLink
                class="button is-text"
                :to="{ name: 'PushEmployee' }"
              >
                <span>Crear empleado</span>
              </RouterLink>
            </template>
            <template slot="empty">
              No se encontraron empleados con este RFC
            </template>
            <template slot-scope="props">
              <div class="media">
                <div class="media-left">
                  Número de Empleado: {{ props.option.employedNumber }}
                </div>
                <div class="media-content">
                  Nombre: {{ props.option.name }} <br>
                  RFC: {{ props.option.rfc.rfc }} <br>
                  <small>
                    CURP: {{ props.option.rfc.curp }}
                  </small>
                </div>
              </div>
            </template>
          </BAutocomplete>
        </BField>
      </div>
      <div class="column is-12">
        <BField label="RFC">
          <BInput
            :value="rfc"
            disabled
          />
        </BField>
      </div>
      <div class="column is-12">
        <BField label="Nombre">
          <BInput
            :value="name"
            disabled
          />
        </BField>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import debounce from 'lodash/debounce';

import api from '@/lib/api';

export default {
  name: 'PayrollReceiver',
  data() {
    return {
      isFetching: false,
      rfc: '',
      employees: [],
      selected: null,
    };
  },
  computed: {
    ...mapState({
      name: state => state.employee.name,
    }),
    canceled() {
      return [201, 202].includes(this.status);
    },
    text() {
      return this.$store.state.employee.rfc;
    },
  },
  methods: {
    getEmployeesByRfc: debounce(async function getEmployeesByCompany() {
      if (this.text.length < 3) return;

      this.isFetching = true;

      const { rows } = await api.employees.getAllByCompany(
        this.$store.state.auth.companyId,
        { rfc: this.text },
      );

      this.employees = rows;

      this.isFetching = false;
    }, 800),
    onSelect(option) {
      this.selected = option;
      const {
        user,
        rfc,
        company,
        payments,
        ...employee
      } = option;

      this.rfc = rfc.rfc;
      this.name = employee.name;

      this.$store.commit('employee/setValues', {
        ...company,
        ...rfc,
        ...user,
        ...employee,
      });
      this.$store.commit('payroll/setPercepts', payments);
    },
    onInput(value) {
      this.$store.commit('employee/setValue', { accessor: 'rfc', value });
    },
  },
};
</script>

<style scoped>
.title {
  margin-bottom: 1rem;
}
</style>
